import {Injectable} from "@angular/core";
import {Observable} from 'rxjs';
import {Serializer, SerializerResponse, Serializers} from "../interfaces/serializer";
import {Site} from "../interfaces/site";
import {environment} from "../../../environments/environment";
import {HttpBackend, HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {DataSetMetric, Metric} from '../interfaces/metrics';
import {SerializerUtils} from "../libraries/serializer-utils";
import {SavedReport} from "../interfaces/saved-reports";
import {Space} from '../interfaces/space';
import {DataSetConditionalDimension, DataSetDimension, GeneralDimension} from '../interfaces/dimensions';
import {Channel} from '../interfaces/channel';

@Injectable()
export class PublicReportsService {

  public httpWithoutInterceptor: HttpClient;

  constructor(
    protected readonly handler: HttpBackend
  ) {
    this.httpWithoutInterceptor = new HttpClient(handler);
  }

  public getChannels(uuid: string, jwtToken: string): Observable<SerializerResponse<Serializers<Channel>>> {
    return this.httpWithoutInterceptor.get<SerializerResponse<Serializers<Channel>>>(`${environment.baseUrl}/api/reports/${uuid}/dimension/channels`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    });
  }
  public getSpace(uuid: string, jwtToken: string): Observable<SerializerResponse<Serializer<Space>>> {
    return this.httpWithoutInterceptor.get<SerializerResponse<Serializer<Space>>>(`${environment.baseUrl}/api/reports/${uuid}/space`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    });
  }

  public getReport(uuid: string, jwtToken: string): Observable<SerializerResponse<Serializer<SavedReport>>> {
    return this.httpWithoutInterceptor.get<SerializerResponse<Serializer<SavedReport>>>(`${environment.baseUrl}/api/reports/${uuid}`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    });
  }

  public getDataSet(uiid: string, jwtToken: string): Observable<SerializerResponse<Serializer<Site>>> {
    return this.httpWithoutInterceptor.get<SerializerResponse<Serializer<Site>>>(`${environment.baseUrl}/api/reports/${uiid}/data-set`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    });
  }

  public getGeneralDimensions(uuid: string, jwtToken: string): Observable<SerializerResponse<Serializers<GeneralDimension>>> {
    return this.httpWithoutInterceptor.get<SerializerResponse<Serializers<GeneralDimension>>>(`${environment.baseUrl}/api/reports/${uuid}/general-dimensions`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    })
      .pipe(
        tap((response: SerializerResponse<Serializers<GeneralDimension>>): void => {
          SerializerUtils.joinRelationships(response, ['data_set_dimensions_group', 'data_source']);
        })
      );
  }

  public getDataSetDimensions(uuid: string, jwtToken: string): Observable<SerializerResponse<Serializers<DataSetDimension>>> {
    return this.httpWithoutInterceptor.get<SerializerResponse<Serializers<DataSetDimension>>>(`${environment.baseUrl}/api/reports/${uuid}/data-set-dimensions`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    })
      .pipe(
        tap((response: SerializerResponse<Serializers<DataSetDimension>>): void => {
          SerializerUtils.joinRelationships(response, ['data_set_dimensions_group', 'data_source']);
        })
      );
  }

  public getDataSetConditionalDimensions(uuid: string, jwtToken: string): Observable<SerializerResponse<Serializers<DataSetConditionalDimension>>> {
    return this.httpWithoutInterceptor.get<SerializerResponse<Serializers<DataSetConditionalDimension>>>(`${environment.baseUrl}/api/reports/${uuid}/data-set-conditional-dimensions`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    })
      .pipe(
        tap((response: SerializerResponse<Serializers<DataSetConditionalDimension>> ): void => {
          SerializerUtils.joinRelationships(response, ['data_set_dimensions_group', 'data_source']);
        })
      );
  }

  public getDataSetMetrics(uuid: string, jwtToken: string): Observable<SerializerResponse<Serializers<DataSetMetric>>> {
    return this.httpWithoutInterceptor.get(`${environment.baseUrl}/api/reports/${uuid}/data-set-metrics`, {
      headers: {
        'Authorization': 'Bearer ' + jwtToken
      }
    }).pipe(
      tap((metrics: SerializerResponse<Serializers<DataSetMetric>>) => {
        SerializerUtils.joinRelationships(metrics, ['data_source', 'data_set_metrics_group']);
      })
    );
  }

  public checkSavedReportPassword(uuid: string, password: string): Observable<any> {
    return this.httpWithoutInterceptor.post(`${environment.baseUrl}/api/reports/${uuid}`, {
      password: password
    });
  }

}
